import React from 'react';
import './BlackberryMap.scss';

const BlackberryMap = () => {
  return (
    <section className="store-location">
      <div className="store-location__container">
        <div className="store-location__details">
          <h2 className="store-location__title">Visit Our Store</h2>
          <div className="store-location__info">
            <div className="store-location__item">
              <span className='material-symbols-outlined'>location_on</span>
              <div className="store-location__text">
                <h4>Address</h4>
                <p>Plot 11, Block F2, Sector 11, Rohini, New Delhi, 110085</p>
              </div>
            </div>
            
            <div className="store-location__item">
              <span className='material-symbols-outlined'>phone</span>
              <div className="store-location__text">
                <h4>Phone</h4>
                <p>+91 8368533288</p>
              </div>
            </div>
            
            <div className="store-location__item">
              <span className='material-symbols-outlined'>email</span>
              <div className="store-location__text">
                <h4>Email</h4>
                <p>elnorastayintrend@gmail.com</p>
              </div>
            </div>
            
            <div className="store-location__item">
              <span className='material-symbols-outlined'>access_time</span>
              <div className="store-location__text">
                <h4>Store Hours</h4>
                <p>Monday - Saturday: 10:00 AM - 9:00 PM</p>
                <p>Sunday: 11:00 AM - 6:00 PM</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="store-location__map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1234.5678!2d-74.0060!3d40.7128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM40zMCc0Ni4xIk4gNzTCsDAwJzIxLjYiVw!5e0!3m2!1sen!2sus!4v1234567890"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default BlackberryMap;
